module.exports = __webpack_public_path__ + "static/img/img1-bur.890e5a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img1-bur.png
// module id = pnPE
// module chunks = 1